exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}.channel{max-width:800px;margin:0 auto;display:flex}.github-link{width:16px;height:16px;opacity:.5}.github-link:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4c8bb9d5","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 42
// module chunks = 0